export const findItemById = (arr, id) =>
  (arr && arr.filter((el) => el.ID === id)[0]) || "";
